export default __webpack_public_path__ + "static/media/holy-water.f9f9687d.png";